<template>
	<div style="min-width: 1000px">
		<!-- <vs-popup ref="popupContainer" :active.sync="showDetailPopup" :title="`Liste des achats pour la période ${formatToFrenchDateString(dateFromFilter)} - ${formatToFrenchDateString(dateToFilter)}`">
      <vs-table :data="providerPurchasesDetail" stripe auto-resize>
      <template slot="thead">
          <vs-th class="text-center">Société</vs-th>
          <vs-th class="text-center">Numéro de contrat</vs-th>
          <vs-th class="text-center">Service</vs-th>
          <vs-th class="text-center">Prestataire</vs-th>
          <vs-th class="text-center">Prix Achat (HT)</vs-th>
          <vs-th class="text-center">Date Achat</vs-th>
          <vs-th class="text-center">Récurrence</vs-th>
          <vs-th class="text-center">Est un achat récurrent ?</vs-th>
          <vs-th class="text-center">Facturable</vs-th>
          <vs-th class="text-center">Commentaire</vs-th>
      </template>

      <template>
          <vs-tr :key="index" v-for="(purchase, index) in providerPurchasesDetail">
            <vs-td :data="purchase.contract_society_id" class="text-center">{{ getSocietyIdToName(purchase.contract_society_id) }}</vs-td>
            <vs-td :data="purchase.contract_id" class="text-center">{{ purchase.contract_id }}</vs-td>
            <vs-td :data="purchase.service_id" class="text-center">{{ getServiceIdToName(purchase.service_id )}}</vs-td>
            <vs-td :data="purchase.users_id" class="text-center"> {{ getProviderIdToName(purchase.users_id) }}</vs-td>
            <vs-td :data="purchase.price" class="text-right"> {{ purchase.recurrence_date ? convertInternationalNumberToFrenchCurrency(purchase.recurrence_price) : convertInternationalNumberToFrenchCurrency(purchase.price) }}</vs-td>
            <vs-td :data="purchase.bought_at" class="text-center"> {{ purchase.recurrence_date ? getDateToFrenchFormat(formatDate(purchase.recurrence_date)) : getDateToFrenchFormat(formatDate(purchase.bought_at))  }}</vs-td>
            <vs-td :data="purchase.recurrence" class="text-center"> {{ getPurchaseFrequency(purchase.recurrence) }}</vs-td>
            <vs-td :data="purchase.recurrence_date" class="text-center"> {{ purchase.recurrence_date ? "Oui" : "Non" }}</vs-td>
            <vs-td :data="purchase.is_billable" class="text-center"> {{ getUserDashboardAccess(purchase.is_billable) }}</vs-td>
            <vs-td :data="purchase.commentary" class="text-center"> {{ purchase.commentary }}</vs-td>
          </vs-tr>
      </template>
    </vs-table>
    </vs-popup> -->
		<div class="vx-row w-full">
			<div class="vx-col">
				<h3>Filtres :</h3>
			</div>
			<!-- <div class="vx-col px-1 mb-2 w-1/6">
        <vs-select
          v-model="providerFilter"
          class="w-full select-large"
          placeholder="Prestataire"
          autocomplete
        >
          <vs-select-item
          value=""
          text="Tous les prestataires"
          class="w-full"
          />
          <vs-select-item
          :key="index"
          :value="item.id + 1"
          :text="item.society"
          v-for="(item, index) in providers"
          class="w-full"
          />
        </vs-select>
      </div>
      <div class="vx-col px-1 mb-2 w-1/6">
        <vs-select
          v-model="recurrenceFilter"
          class="w-full select-large"
          placeholder="Récurrence"
        >
          <vs-select-item
          value=""
          text="Toutes les récurrences"
          class="w-full"
          />
          <vs-select-item
          :key="index"
          :value="item.value + 1"
          :text="item.text"
          v-for="(item, index) in frequencyOptions"
          class="w-full"
          />
        </vs-select>
      </div> -->
			<div class="vx-col mb-2 px-1 w-1/6">
				<!-- DATE -->
				<vx-input-group class="w-full bottom">
					<template slot="prepend">
						<div class="prepend-text bg-primary">
							<span class="flex"
								><vs-icon icon="calendar_today" size="small"></vs-icon
							></span>
						</div>
					</template>
					<flat-pickr
						class="w-full"
						v-model="dateFilter"
						placeholder="Date"
						:config="configDatePicker"
					/>
				</vx-input-group>
				<!-- /DATE -->
			</div>
			<!-- <div class="vx-col mb-2 px-1 w-1/6"> -->
			<!-- DATE -->
			<!-- <vx-input-group class="w-full bottom">
          <template slot="prepend">
            <div class="prepend-text bg-primary">
              <span class="flex"
                ><vs-icon icon="calendar_today" size="small"></vs-icon
              ></span>
            </div>
          </template>
          <flat-pickr
            class="w-full"
            v-model="dateToFilter"
            placeholder="Date de fin"
            :config="configDatePicker"
          />
        </vx-input-group> -->
			<!-- /DATE -->
			<!-- </div> -->
			<!-- <div class="vx-col w-1/6">
        <vs-button color="primary" @click="displayProvidersPurchases(dateFromFilter, dateToFilter)">Rechercher</vs-button>
      </div> -->
		</div>
		<vs-table :data="maxBudgetData" stripe auto-resize>
			<template slot="thead">
				<vs-th>Client</vs-th>
				<vs-th>Budget max</vs-th>
				<vs-th>Total achat</vs-th>
				<vs-th>Total revente</vs-th>
				<vs-th>Taux revente/achat</vs-th>
			</template>

			<template slot-scope="{ data }">
				<vs-tr :key="index" v-for="(society, index) in data">
					<vs-td :data="society.society_id">
						{{ getSocietyIdToName(society.society_id) }}</vs-td
					>
					<vs-td :data="society.max_budget" class="text-right">
						{{
							convertInternationalNumberToFrenchCurrency(society.max_budget)
						}}</vs-td
					>
					<vs-td :data="society.purchases_total" class="text-right">
						{{
							convertInternationalNumberToFrenchCurrency(
								society.purchases_total
							)
						}}</vs-td
					>
					<vs-td :data="society.resell_total" class="text-right">
						{{
							convertInternationalNumberToFrenchCurrency(society.resell_total)
						}}</vs-td
					>
					<vs-td :data="society.sale_rate" class="text-right">
						{{ society.sale_rate }}</vs-td
					>
				</vs-tr>
			</template>
		</vs-table>
	</div>
</template>

<script>
import Vue from "vue";
import store from "@/store/store";
import utilsMixin from "@/mixins/utilsMixin.js";
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
import Purchase from "@/entities/Purchase";
import ValidationPopup from "@/components/popups/ValidationPopup";
import ContractInfo from "@/components/forms/contract/ContractInfo";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
	name: "PurchasesTableRecapBudgetMediaMax",
	props: {
		purchases: Array,
		apiUrl: String,
		// services: Array,
	},
	mixins: [utilsMixin, dbFieldConvertorMixin],
	components: {
		flatPickr,
		ContractInfo,
	},
	data() {
		return {
			maxBudgetData: null,
			selectedYear: null,
			selectedMonth: null,

			apiErrorMsg: null, // catching api error message
			showDetailPopup: false,
			purchaseToDelete: null,
			displayedPurchases: [],
			providerPurchasesDetail: [],
			selectedContract: null,
			//FILTERS
			providerFilter: null,
			recurrenceFilter: null,
			dateFilter: null,
			dateFromFilter: null,
			dateToFilter: null,
			configDatePicker: {
				dateFormat: "m/Y",
			},
		};
	},
	created() {
		this.getAllSocieties();
		this.getAllProviders();
		this.getAllServices();
		/*
		 * this.getLastMonthFromToDate()
		 * this.displayProvidersPurchases(this.dateFromFilter, this.dateToFilter)
		 */
		let today = new Date(Date.now());
		this.selectedYear = today.getFullYear();
		this.selectedMonth = today.getMonth() + 1;
		this.getSaleRateData(this.selectedYear, this.selectedMonth);
	},
	mounted() {},
	computed: {
		societies: () => {
			return store.state.societies;
		},
		providers: () => {
			return store.state.providers;
		},
		services: () => {
			return store.state.services;
		},
	},
	watch: {
		/*
		 * purchases: function(){
		 *   //console.log("purchases watch")
		 *   this.displayProvidersPurchases(this.dateFromFilter, this.dateToFilter) // ATTENTION AUX FILTRES
		 * },
		 */
		dateFilter: function (data) {
			// //console.log("dateFilter",data)
			this.selectedYear = data.split("/")[1];
			this.selectedMonth = data.split("/")[0];
			this.getSaleRateData(this.selectedYear, this.selectedMonth);
		},
	},

	methods: {
		getSaleRateData(year, month) {
			this.$http
				.get(this.apiUrl + `purchase/allmxbgt/${year}/${month}`)
				.then((maxBudgetData) => {
					// //console.log("maxBudgetData", maxBudgetData.data)
					this.maxBudgetData = maxBudgetData.data;
				})
				.catch((err) => {
					//console.log(err);
					this.maxBudgetData = null;
				});
		},

		formatToFrenchDateString(date) {
			if (date.split("/").length > 1) {
				return date;
			} else {
				let re = new RegExp("([T|Z])", "g");
				let strDate = date.replace(re, " ");
				let dateObj = new Date(strDate);
				const ye = new Intl.DateTimeFormat("fr", { year: "numeric" }).format(
					dateObj
				);
				const mo = new Intl.DateTimeFormat("fr", { month: "2-digit" }).format(
					dateObj
				);
				const da = new Intl.DateTimeFormat("fr", { day: "2-digit" }).format(
					dateObj
				);
				return `${da}/${mo}/${ye}`;
			}
		},

		formatToInternationalDateString(date) {
			if (date.split("/").length > 1) {
				let strDate = date.split("/").reverse().join("-");
				return strDate;
			} else {
				return date;
			}
		},

		getLastMonthFromToDate() {
			let today = new Date(Date.now());
			let year =
				today.getMonth() - 1 < 0
					? today.getFullYear() - 1
					: today.getFullYear();
			let month = today.getMonth();
			// let day = today.getDate()
			this.dateFromFilter = new Date(year, month - 1, 1).toISOString();
			this.dateToFilter = new Date(year, month, 0).toISOString();
			/*
			 * //console.log(this.dateFromFilter)
			 * //console.log(this.dateToFilter)
			 */
		},

		displayProvidersPurchases(strFromDate, strToDate) {
			//fromDate, toDate
			//console.log(strFromDate, strToDate);
			let fromDate = new Date(strFromDate.split("/").reverse().join("-"));
			let toDate = new Date(strToDate.split("/").reverse().join("-"));
			// //console.log(fromDate, toDate)
			let displayedPurchases = [];
			for (let purchase of this.purchases) {
				let re = new RegExp("([T|Z])", "g");
				// //console.log(purchase.recurrence_date, purchase.bought_at)
				let purchaseDate = purchase.recurrence_date
					? purchase.recurrence_date.replace(re, " ")
					: purchase.bought_at.replace(re, " ");
				let purchaseDateObj = new Date(purchaseDate);
				// //console.log(purchaseDateObj,fromDate,toDate,purchaseDateObj <= toDate && purchaseDateObj >= fromDate)
				if (purchaseDateObj <= toDate && purchaseDateObj >= fromDate) {
					let foundPurchaseIndex = displayedPurchases.findIndex(
						(curr_purchase) => curr_purchase.provider_id == purchase.users_id
					);
					if (foundPurchaseIndex < 0) {
						displayedPurchases.push({
							provider_id: purchase.users_id,
							totalAmount: purchase.recurrence_date
								? purchase.recurrence_price
								: purchase.price,
							contracts: [purchase.contract_id],
						});
					} else {
						displayedPurchases[foundPurchaseIndex].totalAmount =
							displayedPurchases[foundPurchaseIndex].totalAmount +
							purchase.price;
						if (
							displayedPurchases[foundPurchaseIndex].contracts.findIndex(
								(curr_contract) => curr_contract == purchase.contract_id
							) < 0
						)
							displayedPurchases[foundPurchaseIndex].contracts.push(
								purchase.contract_id
							);
					}
				}
			}

			this.displayedPurchases = displayedPurchases;
		},

		/**
		 * Return true if a filter has been set
		 * @return {Boolean} - Is filter set ?
		 */
		isFilterSet() {
			////console.log("isFilterSet BEGIN")
			if (
				this.contractNumberFilterOn ||
				this.dateFromFilterOn ||
				this.dateToFilterOn ||
				this.expertiseFilterOn ||
				this.providerFilterOn ||
				this.societyFilterOn ||
				this.recurrenceFilterOn
			)
				return true;
			return false;
		},

		/**
		 * Return list of filtered purchases A CHANGER
		 * @param {String} contractNumberFilter - Contract number filter search value
		 * @param {String} societyFilter - String to match in society name
		 * @param {String} recurrenceFilter - Recurrence's Frequency number filter search value
		 * @return {List} - Purchases' list filtered
		 */
		filterPurchases(purchases) {
			////console.log("filterProviders BEGIN")
			let purchasesList = [];

			let searchKeyList = {};
			this.dateFromFilterOn
				? (searchKeyList["dateFromFilter"] = new Date(
						this.dateFromFilter.split("/").reverse().join("-")
				  ))
				: false;
			this.dateToFilterOn
				? (searchKeyList["dateToFilter"] = new Date(
						this.dateToFilter.split("/").reverse().join("-")
				  ))
				: false;
			this.expertiseFilterOn
				? (searchKeyList["expertiseFilter"] = this.expertiseFilter)
				: false;
			this.societyFilterOn
				? (searchKeyList["societyFilter"] = this.societyFilter)
				: false;
			this.contractNumberFilterOn
				? (searchKeyList["contractNumberFilter"] =
						this.contractNumberFilter.toString())
				: false;
			this.providerFilterOn
				? (searchKeyList["providerFilter"] = this.providerFilter)
				: false;
			this.recurrenceFilterOn
				? (searchKeyList["recurrenceFilter"] = this.recurrenceFilter)
				: false;

			for (let purchaseToFilter of purchases) {
				/*
				 * //console.log(purchaseToFilter)
				 *  let society_name = this.getSocietyName(purchaseToFilter.contract_society_id)
				 */

				// if(society_name != "") society_name = society_name.toLowerCase()

				let purchaseSearchKeyList = {};
				let purchaseDate = purchaseToFilter.recurrence_date
					? purchaseToFilter.recurrence_date
					: purchaseToFilter.bought_at;
				let re = new RegExp("([T|Z])", "g");
				purchaseDate = purchaseDate ? purchaseDate.replace(re, " ") : null;
				purchaseDate = purchaseDate ? new Date(purchaseDate) : null;
				this.dateFromFilterOn
					? (purchaseSearchKeyList["dateFromFilter"] = purchaseDate)
					: false;
				this.dateToFilterOn
					? (purchaseSearchKeyList["dateToFilter"] = purchaseDate)
					: false;
				this.expertiseFilterOn
					? (purchaseSearchKeyList["expertiseFilter"] =
							purchaseToFilter.service_id)
					: false;
				this.societyFilterOn
					? (purchaseSearchKeyList["societyFilter"] =
							purchaseToFilter.contract_society_id)
					: false;
				this.contractNumberFilterOn
					? (purchaseSearchKeyList["contractNumberFilter"] =
							purchaseToFilter.contract_id.toString())
					: false;
				this.providerFilterOn
					? (purchaseSearchKeyList["providerFilter"] =
							purchaseToFilter.users_id)
					: false;
				this.recurrenceFilterOn
					? (purchaseSearchKeyList["recurrenceFilter"] =
							purchaseToFilter.recurrence)
					: false;

				let check = true;

				for (let key in searchKeyList) {
					/*
					 * //console.log("TYPE")
					 * //console.log(typeof purchaseSearchKeyList[key])
					 */
					if (typeof searchKeyList[key] == "string") {
						if (typeof purchaseSearchKeyList[key] == "string") {
							if (!purchaseSearchKeyList[key].includes(searchKeyList[key])) {
								check = false;
								break;
							}
						} else if (typeof purchaseSearchKeyList[key] == "object") {
							////console.log("Array")
							let checkLoop = false;
							for (let value of purchaseSearchKeyList[key]) {
								let service_name = this.getServiceIdToName(value).toLowerCase();
								/*
								 * //console.log(service_name)
								 * //console.log(searchKeyList[key])
								 */
								if (service_name.includes(searchKeyList[key])) {
									////console.log("checkLoop = true;")
									checkLoop = true;
								}
							}
							if (!checkLoop) {
								check = checkLoop;
								break;
							}
						}
					} else if (searchKeyList[key] instanceof Date) {
						if (key == "dateFromFilter") {
							// //console.log("dateFromFilter", searchKeyList[key].toISOString(), purchaseSearchKeyList[key].toISOString(), searchKeyList[key] <= purchaseSearchKeyList[key])
							check = searchKeyList[key] <= purchaseSearchKeyList[key];
						}
						if (key == "dateToFilter") {
							check = searchKeyList[key] >= purchaseSearchKeyList[key];
						}
						if (!check) break;
					} else {
						if (purchaseSearchKeyList[key] != searchKeyList[key] - 1) {
							check = false;
							break;
						}
					}
				}

				if (check) purchasesList.push(purchaseToFilter);
			}
			/*
			 * return result
			 * //console.log("filterProviders END")
			 */
			return purchasesList;
		},

		searchAndDisplay() {
			this.displayedPurchases = this.filterPurchases(
				this.displayedPurchasesFull
			);
		},

		displayDetails(provider_id) {
			//console.log(this.dateFromFilter);
			//console.log(this.dateToFilter);
			let fromDate = new Date(
				this.formatToInternationalDateString(this.dateFromFilter)
			);
			let toDate = new Date(
				this.formatToInternationalDateString(this.dateToFilter)
			);
			//console.log(fromDate);
			//console.log(toDate);
			let providerPurchasesDetail = this.purchases.filter((purchase) => {
				let purchaseDate = purchase.recurrence_date
					? purchase.recurrence_date
					: purchase.bought_at;
				let re = new RegExp("([T|Z])", "g");
				purchaseDate = purchaseDate ? purchaseDate.replace(re, " ") : null;
				purchaseDate = purchaseDate ? new Date(purchaseDate) : null;
				if (
					purchase.users_id == provider_id &&
					purchaseDate <= toDate &&
					purchaseDate >= fromDate
				) {
					return purchase;
				}
			});
			// providerPurchasesDetail = providerPurchasesDetail.filter(purchase => purchase.users_id == provider_id)
			this.providerPurchasesDetail = providerPurchasesDetail;
			this.showDetailPopup = true;
		},

		/**
		 * Add prefix to url using the mixin
		 */
		getPrefixedUrl(url) {
			return this.urlPrefixAdder(url);
		},

		/**
		 * Returns service name from service id
		 * @param {Number} service_id - service id to retrieve name from
		 * @return {String} - name of service id
		 */
		getServiceIdToName(service_id) {
			let service_name = "";
			let service = this.services.find((service) => service.id == service_id);
			if (service != undefined && service.name != undefined) {
				service_name = service.name;
			}
			return service_name;
		},

		getSocietyIdToName(society_id) {
			let society_name = "";
			let society = this.societies.find((society) => society.id == society_id);
			if (society != undefined && society.name != undefined) {
				society_name = society.name;
			}
			return society_name;
		},

		getProviderIdToName(provider_id) {
			let provider_name = "";
			let provider = this.providers.find(
				(provider) => provider.id == provider_id
			);
			if (provider != undefined && provider.society != undefined) {
				provider_name = provider.society;
			}
			return provider_name;
		},

		formatDate(date_input) {
			if (date_input && date_input.length > 10) {
				return date_input.substring(0, 10);
			} else {
				return date_input;
			}
		},
		getAllServices() {
			this.$store.dispatch("getAllServices");
		},
		/**
		 * Get all societies in store states
		 */
		getAllSocieties() {
			this.$store.dispatch("getAllSocieties");
		},
		getAllProviders() {
			this.$store.dispatch("getAllProviders");
		},

		deletePurchase(purchase) {
			let purchaseToDelete = new Purchase(purchase);
			//console.log(purchase);
			if (purchaseToDelete.recurrence_id) {
				purchaseToDelete.deleterc(
					purchaseToDelete.recurrence_id,
					(err, res) => {
						if (err)
							if (res) {
								//console.log(err);
								this.$emit("delete-line", purchase);
							}
					}
				);
			} else {
				purchaseToDelete.delete(purchaseToDelete.id, (err, res) => {
					if (err)
						if (res) {
							//console.log(err);
							this.$emit("delete-line", purchase);
						}
				});
			}
		},

		displayContractPopup(contractId) {
			//console.log("displayContractPopup", contractId);
			// //Initialisation des données pour le popup
			// this.$http
			// .get(this.apiUrl + "contract/get/" + contractId)
			// .then(contract => {
			//     //console.log("contract", contract)
			//     //Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			// this.selectedContract = contract.data[0]
			this.selectedContract = contractId;
			this.$emit("contract-info-popup", contractId);
			/*
			 * })
			 * .catch(err => {
			 *     //console.log(err)
			 * })
			 */
		},

		displayValidationPopup(purchase) {
			this.purchaseToDelete = purchase;
			this.showDetailPopup = true;
		},

		accept() {
			this.deletePurchase(this.purchaseToDelete);
			this.showDetailPopup = false;
		},

		decline() {
			this.purchaseToDelete = null;
			this.showDetailPopup = false;
		},

		updatePurchase(purchase) {
			if (purchase.recurrence_id) {
				let propsData = {
					propsData: {
						objToRedirect: purchase,
						title:
							"Voulez-vous modifier l'achat original ou l'achat récurrent ?",
						optionOneText: "L'achat original",
						optionTwoText: "L'achat récurrent",
						isActive: true,
					},
				};

				//console.log("propsData", propsData);
				//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
				let ComponentClass = Vue.extend(ValidationPopup);
				//console.log("ComponentClass");
				//console.log(ComponentClass);
				let validationPopup = new ComponentClass(propsData);
				validationPopup.$mount();
				validationPopup.$on("option-one", (purchase) => {
					this.updateMainPurchase(purchase);
				});
				validationPopup.$on("option-two", (purchase) => {
					this.updateRecurringPurchase(purchase);
				});
				this.$refs.popupContainer.appendChild(validationPopup.$el);
				//console.log("this.$refs.popupContainer");
				//console.log(this.$refs.popupContainer);
			} else {
				this.updateMainPurchase(purchase);
			}
		},

		updateMainPurchase(purchase) {
			//console.log("modify-purchase");
			this.$emit("modify-purchase", purchase);
		},

		updateRecurringPurchase(purchase) {
			//console.log("modify-recurring");
			this.$emit("modify-recurring", purchase);
		},

		renewPurchase(purchaseId) {
			this.$emit("renew-purchase", purchaseId);
		},
	},
};
</script>

<style scoped>
.center {
	justify-content: center;
}
</style>
